import { onMounted, onUnmounted } from 'vue'

export function usePrint(targetSelector: string = '#print-area') {
  let savedScrollY = 0

  const handleBeforePrint = () => {
    savedScrollY = window.scrollY

    document.documentElement.style.setProperty('overflow', 'visible', 'important')
    document.body.style.setProperty('overflow', 'visible', 'important')
    document.body.style.setProperty('height', 'auto', 'important')

    const scrollElement = document.querySelector('.scroll') as HTMLElement
    const targetElement = document.querySelector(targetSelector) as HTMLElement

    if (scrollElement) {
      scrollElement.style.setProperty('height', '100vh', 'important')
      scrollElement.style.setProperty('max-height', '100vh', 'important')
      scrollElement.style.setProperty('overflow', 'visible', 'important')
    }

    if (targetElement) {
      targetElement.style.setProperty('overflow', 'visible', 'important')
      targetElement.style.setProperty('height', 'auto', 'important')
      targetElement.style.setProperty('position', 'static', 'important')
    }

    window.scrollTo(0, 0)
  }
  
  const handleAfterPrint = () => {
    window.scrollTo(0, savedScrollY)

    const targetElement = document.querySelector(targetSelector) as HTMLElement
    const scrollElement = document.querySelector('.scroll') as HTMLElement

    if (targetElement) {
      targetElement.style.removeProperty('overflow')
      targetElement.style.removeProperty('height')
      targetElement.style.removeProperty('position')
      targetElement.style.removeProperty('max-height')
    }

    if (scrollElement) {
      scrollElement.style.removeProperty('height')
      scrollElement.style.removeProperty('max-height')
      scrollElement.style.removeProperty('overflow')
    }

    document.body.style.setProperty('overflow', 'hidden')
    document.body.style.removeProperty('height')
    document.documentElement.style.removeProperty('overflow')
    document.documentElement.style.removeProperty('height')
  }

  const printPage = () => {
    window.print()
  }
  
  onMounted(() => {
    window.addEventListener('beforeprint', handleBeforePrint)
    window.addEventListener('afterprint', handleAfterPrint)
  })
  
  onUnmounted(() => {
    window.removeEventListener('beforeprint', handleBeforePrint)
    window.removeEventListener('afterprint', handleAfterPrint)
  })
  
  return { printPage }
}
  